import * as ACTION_TYPES from "./action-types";

export const setUserDetails = (data) => ({
  type: ACTION_TYPES.SET_USER_DETAILS,
  payload: data,
});

export const setUserProjects = (data) => ({
  type: ACTION_TYPES.SET_USER_PROJECTS,
  payload: data,
});

export const setVisitingByAdmin = (data) => ({
  type: ACTION_TYPES.SET_VISITING_BY_ADMIN,
  payload: data,
});

export const setAllUserDetails = (data) => ({
  type: ACTION_TYPES.SET_ALL_USER_DETAILS,
  payload: data,
});
